import React, { useContext } from 'react'
import { FormContext } from '../../context/form/FormContext';
import QuestionName from '../styleComponents/QuestionName';

const ScaleSmileys = ({id, question, qDescription, answer, page, setPage, limitPage  }) => {
    const arraySteps = [0,1,2,3,4, 5]
    const { handleChange } = useContext(FormContext)

    const general =  (id, event) => {
        handleChange(id,event)
        if(page !== limitPage){
          setPage(page + 1)
        }
    }


  return (
    <div>
        <QuestionName questionName={question} description={qDescription}/>
        <div className='d-flex justify-content-between mx-auto smiley_container' >
            {
                arraySteps.map((step, i) =>{
                    let value = i + 1
                    return (
                    <div key={`${value}${question}`} className='d-flex align-items-center justify-content-between mb-5'>
                         <button 
                            className={`scale__input_smiles ${answer === value ? 'scale__input-active' : ''}`}
                            id={`${value}${question}`}
                            type='button' 
                            name={question} 
                            value={value} 
                            onClick={() => general(id, {target:{value}})}
                        >
                           <img src={`/emojis/smiley_${value}.svg`} alt='emoji' width={30}/>
                        </button>
                    </div>
                    )
                })
            }
        </div>
    </div>
  )
}

export default ScaleSmileys